"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnFormat = exports.ColumnChartComponent = exports.ColumnFilterType = exports.Orientation = exports.DataLoadingStrategy = void 0;
var DataLoadingStrategy;
(function (DataLoadingStrategy) {
    DataLoadingStrategy["EAGER"] = "EAGER";
    DataLoadingStrategy["LAZY"] = "LAZY";
})(DataLoadingStrategy || (exports.DataLoadingStrategy = DataLoadingStrategy = {}));
var Orientation;
(function (Orientation) {
    Orientation["ROW"] = "ROW";
})(Orientation || (exports.Orientation = Orientation = {}));
var ColumnFilterType;
(function (ColumnFilterType) {
    ColumnFilterType["STRING_SEARCH"] = "STRING_SEARCH";
    ColumnFilterType["RANGE"] = "RANGE";
    ColumnFilterType["DATE"] = "DATE";
})(ColumnFilterType || (exports.ColumnFilterType = ColumnFilterType = {}));
var ColumnChartComponent;
(function (ColumnChartComponent) {
    ColumnChartComponent["XAXIS"] = "XAXIS";
    ColumnChartComponent["LINE"] = "LINE";
    ColumnChartComponent["BAR"] = "BAR";
})(ColumnChartComponent || (exports.ColumnChartComponent = ColumnChartComponent = {}));
var ColumnFormat;
(function (ColumnFormat) {
    ColumnFormat["PERCENTAGE"] = "PERCENTAGE";
    ColumnFormat["DATE"] = "DATE";
    ColumnFormat["BOOLEAN"] = "BOOLEAN";
    ColumnFormat["NUMBER"] = "NUMBER";
    ColumnFormat["CURRENCY"] = "CURRENCY";
    ColumnFormat["LINK"] = "LINK";
    ColumnFormat["TEXT"] = "TEXT";
    ColumnFormat["ARRAY_LINK"] = "ARRAY_LINK";
    ColumnFormat["HONEYCOMB"] = "HONEYCOMB";
})(ColumnFormat || (exports.ColumnFormat = ColumnFormat = {}));
//# sourceMappingURL=Visualization.js.map